@import "../../../global/gx-ide-common.scss";

:host {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  inline-size: 100%;
  position: relative;
}
:host(.animate) {
  animation: fadeIn var(--timing-fast) forwards;
  inset-block-start: 0;
}
.main-container {
  max-width: 320px;
  margin: 0 auto;
  gap: var(--spacing-gap-xl);
  padding: var(--spacing-padding-xl);

  &__icon-wrapper {
    border: 1px dashed var(--color-accent-primary-default);
    border-radius: 50%;
    min-width: 40px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  &__content {
    gap: var(--spacing-gap-m);
  }
}
.main-container,
.main-container__content {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.description {
  // WA: current font style (.body-regular-m) has a tight line-height
  line-height: var(--line-height-spacious) !important;
  color: var(--color-text-neutral-neutral);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    inset-block-start: 5px;
  }
}
